<template>
    <div>
        <ContactEditComponent />
    </div>
</template>
  
<script>
import ContactEditComponent from '@/components/ContactEditComponent.vue';

export default {
    components: {
        ContactEditComponent
    },
};
</script>